import { Injectable, inject } from '@angular/core';
import { saveAs } from 'file-saver';
import { FileSaverUsecase } from '../../../domain/model/file-saver-usecase.enum';
import moment from 'moment';
import { TeilgebietSelectionService } from '../teilgebiet/teilgebiet-selection.service';

@Injectable({
    providedIn: 'root',
})
export class FileSaverService {
    private teilgebietSelectionService = inject(TeilgebietSelectionService);

    private static readonly APPLICATION_PREFIX = 'KASK';
    private static readonly TIMESTAMP_FORMAT = 'YYYY-MM-DD_HH-mm-ss';

    public saveFileByUsecaseAsWestnetz(usecase: FileSaverUsecase, file: Blob, stwId: string | null = null): void {
        const filename = FileSaverService.buildFilename(usecase, stwId, null);
        this.saveFile(filename, file);
    }

    public saveFileByUsecaseAsNvnb(usecase: FileSaverUsecase, file: Blob, teilgebiet: string | null = null): void {
        const hasMultipleTeilgebiete = this.teilgebietSelectionService.hasMultipleTeilgebiete();
        const filename = FileSaverService.buildFilename(usecase, null, hasMultipleTeilgebiete ? teilgebiet : null);
        this.saveFile(filename, file);
    }

    public saveFile(filename: string, file: Blob): void {
        saveAs(file, filename);
    }

    private static buildFilename(usecase: FileSaverUsecase, stwId: string | null, teilgebiet: string | null): string {
        const [
            filenameUsecase,
            fileExtension,
        ] = this.getFilenameUsecaseAndExtensionFromUsecase(usecase);
        const timestamp = moment().format(this.TIMESTAMP_FORMAT);

        let filename = `${this.APPLICATION_PREFIX}_${filenameUsecase}_${timestamp}`;
        let prefix = '';
        if (teilgebiet) {
            prefix = `${prefix}_${teilgebiet}`;
        }
        if (stwId) {
            prefix = `${prefix}_${stwId}`;
        }
        return `${filename}${prefix}.${fileExtension}`;
    }

    private static getFilenameUsecaseAndExtensionFromUsecase(usecase: FileSaverUsecase): [string, string] {
        switch (usecase) {
            case FileSaverUsecase.EXCEL_EXPORT_ERZEUGUNGSANLAGEN:
                return [
                    'Export-Erzeuger',
                    'xlsx',
                ];
            case FileSaverUsecase.CSV_EXPORT_ERZEUGUNGSANLAGEN:
                return [
                    'Erzeuger',
                    'csv',
                ];
            case FileSaverUsecase.CSV_EXPORT_NETZBETREIBER:
                return [
                    'Netzbetreiber',
                    'csv',
                ];
            case FileSaverUsecase.CSV_EXPORT_NETZZUORDNUNGEN:
                return [
                    'Netzzuordnung',
                    'csv',
                ];
            case FileSaverUsecase.CSV_EXPORT_AKTIVE_DATENABFRAGE:
                return [
                    'Aktive-Datenabfrage',
                    'csv',
                ];
            case FileSaverUsecase.CSV_EXPORT_ARCHIVIERTE_DATENABFRAGE:
                return [
                    'Archivierte-Datenabfrage',
                    'csv',
                ];
            default:
                throw new Error(`Usecase(${usecase}) not implemented.`);
        }
    }
}
